import { CombinedError } from '@urql/vue';
import { ApiError } from '~/graphql/wrappers/api-error';

export default class ApiResponse<T = Mutation | Query> {
  protected readonly error?: ApiError;
  private _data?: T;
  private data: T = this._data as T;

  constructor(combinedError?: CombinedError) {
    if (combinedError) {
      if (combinedError.networkError) {
        this.error = new ApiError()
          .setCode('NETWORK_ERROR')
          .fromError(combinedError.networkError);
      } else if (
        combinedError.graphQLErrors &&
        combinedError.graphQLErrors[0]
      ) {
        this.error = new ApiError().fromError(combinedError.graphQLErrors[0]);
      } else {
        this.error = new ApiError('Unknown API error');
      }
    }
  }

  protected setData(data: T) {
    this._data = data;
    this.data = data;
  }

  hasError(): boolean {
    return this.error !== undefined;
  }

  hasData(): boolean {
    return this._data !== undefined;
  }

  getData(): T {
    return this.data;
  }

  getError(): ApiError | undefined {
    return this.error;
  }
}
